import SearchInputContainer from './SearchInputContainer';

export default SearchInputContainer;
